import API from 'api'
import { catchError } from 'domains/errors'
import { Store } from 'domains/store'
import { Events } from 'minivents'
import { FunctionComponent } from 'preact'
import { useErrorBoundary } from 'preact/hooks'
import { Provider } from 'react-redux'
import SeamlyChat from 'ui/components/core/seamly-chat'
import ComponentFilter from '../conversation/component-filter'
import SeamlyActivityMonitor from './seamly-activity-monitor'
import { SeamlyApiContext, SeamlyEventBusContext } from './seamly-api-context'
import SeamlyEventSubscriber from './seamly-event-subscriber'
import SeamlyFileUpload from './seamly-file-upload'
import SeamlyIdleDetachCounter from './seamly-idle-detach-counter'
import SeamlyInitializer from './seamly-initializer'
import SeamlyInstanceFunctionsLoader from './seamly-instance-functions-loader'
import SeamlyLiveRegion from './seamly-live-region'
import SeamlyNewNotifications from './seamly-new-notifications'
import SeamlyReadState from './seamly-read-state'

const SeamlyCore: FunctionComponent<{
  store: Store
  eventBus: Events
  api: API
}> = ({ store, children, eventBus, api }) => {
  useErrorBoundary((error) => {
    console.error(error)
    store.dispatch(catchError(error))
  })

  return (
    <Provider store={store}>
      <SeamlyEventBusContext.Provider value={eventBus}>
        <SeamlyApiContext.Provider value={api}>
          <SeamlyLiveRegion>
            <SeamlyChat>
              <ComponentFilter>
                <SeamlyInitializer />
                <SeamlyEventSubscriber />
                <SeamlyReadState />
                <SeamlyNewNotifications />
                <SeamlyIdleDetachCounter />
                <SeamlyActivityMonitor>
                  <SeamlyInstanceFunctionsLoader />
                  <SeamlyFileUpload>{children}</SeamlyFileUpload>
                </SeamlyActivityMonitor>
              </ComponentFilter>
            </SeamlyChat>
          </SeamlyLiveRegion>
        </SeamlyApiContext.Provider>
      </SeamlyEventBusContext.Provider>
    </Provider>
  )
}

export default SeamlyCore
